var React = require('react');

function ToggleOnDuotone (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"fa-group"},[React.createElement("path",{"className":"fa-secondary","d":"M384 384a128 128 0 1 1 128-128 127.93 127.93 0 0 1-128 128z","opacity":"0.4","key":0}),React.createElement("path",{"className":"fa-primary","d":"M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320a128 128 0 1 1 128-128 127.93 127.93 0 0 1-128 128z","key":1})]));
}

ToggleOnDuotone.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"fad","data-icon":"toggle-on","className":"svg-inline--fa fa-toggle-on fa-w-18","role":"img","viewBox":"0 0 576 512"};

module.exports = ToggleOnDuotone;

ToggleOnDuotone.default = ToggleOnDuotone;
